import './Contact.scss';
import Letters from '../Letters';
import { useState, useEffect, useRef } from 'react';
import emailjs from '@emailjs/browser';
import austin from '../../assets/images/austin.jpg';

// EmailJS browser keys are public by design, but they are still better read
// from environment variables (.env.local) than hard-coded. The fallbacks keep
// the form working until those are set.
const SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID || 'service_wj7liva';
const TEMPLATE_ID =
  process.env.REACT_APP_EMAILJS_TEMPLATE_ID || 'template_6qj6luj';
const PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY || 'UW2HOpTXVow6wLqTd';

const EMAIL = 'matthewevwalker@gmail.com';

const Contact = () => {
  const [letterClass, setLetterClass] = useState('text-animate');
  // idle | sending | success | error
  const [status, setStatus] = useState({ state: 'idle', message: '' });
  const formRef = useRef();

  useEffect(() => {
    const timer = setTimeout(() => {
      setLetterClass('text-animate-hover');
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  const sendEmail = (e) => {
    e.preventDefault();

    if (status.state === 'sending') return; // guard against double submits

    setStatus({ state: 'sending', message: '' });

    emailjs
      .sendForm(SERVICE_ID, TEMPLATE_ID, formRef.current, PUBLIC_KEY)
      .then(
        () => {
          setStatus({
            state: 'success',
            message: 'Thanks — your message has been sent. I will get back to you soon.',
          });
          // Clearing the form beats the old window.location.reload(), which
          // threw away the whole single-page app to empty four inputs.
          formRef.current.reset();
        },
        (error) => {
          setStatus({
            state: 'error',
            message: `Something went wrong sending your message. Please try again, or email me directly at ${EMAIL}.`,
          });
          console.error('EmailJS error:', error);
        }
      );
  };

  const isSending = status.state === 'sending';

  return (
    <div className="container contact-page">
      <header className="page-header">
        <h1>
          <Letters
            letterClass={letterClass}
            letterArray={['C', 'o', 'n', 't', 'a', 'c', 't', ' ', 'M', 'e']}
            index={20}
          />
        </h1>
        <p className="lead">
          Have a question, an opportunity, or just want to say hello? Send me a
          message and I will get back to you as soon as I can.
        </p>
      </header>

      <div className="contact-grid">
        <div className="contact-form-panel">
          <form ref={formRef} onSubmit={sendEmail}>
            <div className="field-row">
              <div className="field">
                <label htmlFor="contact-name">Name</label>
                <input
                  id="contact-name"
                  type="text"
                  name="name"
                  autoComplete="name"
                  required
                />
              </div>

              <div className="field">
                <label htmlFor="contact-email">Email</label>
                <input
                  id="contact-email"
                  // `email` rather than `text`: gives free validation and the
                  // right keyboard on phones.
                  type="email"
                  name="email"
                  autoComplete="email"
                  required
                />
              </div>
            </div>

            <div className="field">
              <label htmlFor="contact-subject">Subject</label>
              {/* This input had no `name`, so the browser never submitted it
                  and the subject never reached the email. Add {{subject}} to
                  your EmailJS template to actually use it. */}
              <input
                id="contact-subject"
                type="text"
                name="subject"
                required
              />
            </div>

            <div className="field">
              <label htmlFor="contact-message">Message</label>
              <textarea
                id="contact-message"
                name="message"
                rows="7"
                required
              />
            </div>

            <button
              type="submit"
              className="submit-btn"
              disabled={isSending}
              aria-describedby="form-status"
            >
              {isSending ? 'SENDING…' : 'SEND MESSAGE'}
            </button>

            {/* Announced by screen readers when it changes: `alert` for
                failures so it interrupts, `status` for success so it waits
                for a natural pause. Replaces two window.alert() calls. */}
            <p
              id="form-status"
              className={`form-status ${status.state}`}
              role={status.state === 'error' ? 'alert' : 'status'}
              aria-live={status.state === 'error' ? 'assertive' : 'polite'}
            >
              {status.message}
            </p>
          </form>
        </div>

        <aside className="contact-aside">
          <div className="contact-direct">
            <h2 className="section-label">Prefer email?</h2>
            <a className="email-link" href={`mailto:${EMAIL}`}>
              {EMAIL}
            </a>
          </div>

          <figure className="texas-img">
            <img
              src={austin}
              alt="The Austin, Texas skyline at dusk"
              loading="lazy"
            />
          </figure>
        </aside>
      </div>
    </div>
  );
};

export default Contact;
